import React from 'react';
import { HStack, Text, Box } from '@skin-seoul/design-system';
import { SafeLink } from '@/components/ui/SafeLink';
const convertRankToPath = (taxonomy: string, slug: string) => {
  if (taxonomy === 'brand') {
    return `/brand/${slug}/`;
  }
  if (taxonomy === 'product_cat') {
    return `/collections/${slug}/`;
  }
  return `/product-tag/${slug}/`;
};
interface RankingItemProps {
  rank: number;
  category: string;
  slug: string;
  taxonomy: string;
}
const RankingItem = ({
  rank,
  category,
  slug,
  taxonomy
}: RankingItemProps) => {
  const path = convertRankToPath(taxonomy, slug);
  return <HStack gap={2} alignItems="center" justifyContent="flex-start" width="100%" data-sentry-element="HStack" data-sentry-component="RankingItem" data-sentry-source-file="RankingItem.tsx">
      <Text textStyle={{
      base: 'paragraph.small',
      tablet: 'paragraph.medium'
    }} fontWeight="medium" color="neutral.700" textAlign="left" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="RankingItem.tsx">
        #{rank}
        <Text as="span" fontWeight="normal" data-sentry-element="Text" data-sentry-source-file="RankingItem.tsx">
          {` in`}
        </Text>
      </Text>
      <Box flex={1} data-sentry-element="Box" data-sentry-source-file="RankingItem.tsx">
        <SafeLink href={path} textStyle={{
        base: 'label.medium',
        tablet: 'label.large'
      }} fontWeight="medium" color="primary.400" textAlign="left" wordBreak="break-word" _hover={{
        textDecoration: 'none'
      }} data-sentry-element="SafeLink" data-sentry-source-file="RankingItem.tsx">
          {category}
        </SafeLink>
      </Box>
    </HStack>;
};
export default RankingItem;